import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { AppService } from './app.service';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ExternalCommonService extends AppService {
  constructor(
    public http: HttpClient,
    @Inject('environment') environment: any
  ) {
    super(http, environment);
  }

  getQualificationTypes() {
    return this.http.get<any>(
      this.getEndpoint('QualificationTypeBasic?ActiveOnly=true'),
      this.gethttpOptions()
    );
  }

  geFillingTypes() {
    return this.http.get<any>(
      this.getEndpoint('ExemptionFilingTypeBasic?ActiveOnly=true'),
      this.gethttpOptions()
    );
  }

  getExternalStatusTypes(forSearch = false) {
    if (forSearch) {
      return this.http.get<any>(
        this.getEndpoint(
          'ExternalStatusTypeBasic?ActiveOnly=true&ExternalOnly=true'
        ),
        this.gethttpOptions()
      );
    }
    return this.http.get<any>(
      this.getEndpoint('ExternalStatusTypeBasic?ActiveOnly=true'),
      this.gethttpOptions()
    );
  }

  getRequestTypes() {
    return this.http.get<any>(
      this.getEndpoint('ExemptionRequestTypeBasic?ActiveOnly=true'),
      this.gethttpOptions()
    );
  }

  getCountryTypes() {
    return of([{ id: 1, name: 'USA' }]);
    return this.http.get<any>(
      this.getEndpoint('CountyBasic?ActiveOnly=true'),
      this.gethttpOptions()
    );
  }

  getCountyTypes() {
    return this.http.get<any>(
      this.getEndpoint('CountyBasic?ActiveOnly=true'),
      this.gethttpOptions()
    );
  }

  getStateTypes() {
    return this.http.get<any>(
      this.getEndpoint('StateBasic?ActiveOnly=true'),
      this.gethttpOptions()
    );
  }

  getCityTypes() {
    return this.http.get<any>(
      this.getEndpoint('CityBasic?ActiveOnly=true'),
      this.gethttpOptions()
    );
  }

  getPaymentTypes() {
    return this.http.get<any>(
      this.getEndpoint('PaymentTypeBasic?ActiveOnly=true'),
      this.gethttpOptions()
    );
  }

  getRequestStatusTypes() {
    return this.http.get<any>(
      this.getEndpoint('RequestStatusTypeBasic?ActiveOnly=true'),
      this.gethttpOptions()
    );
  }

  getDocumentImageType() {
    return this.http.get<any>(
      this.getEndpoint('DocumentImageTypeBasic?ActiveOnly=true'),
      this.gethttpOptions()
    );
  }

  getConstructionTypes() {
    return this.http.get<any>(
      this.getEndpoint('ConstructionServiceBasic?ActiveOnly=true'),
      this.gethttpOptions()
    );
  }

  getPrintDoc(id: number) {
    return this.http.get<any>(
      this.getEndpoint(`ExemptionFilingRequestBasic/${id}/PrintApplication`),
      {
        headers: this.gethttpOptionsFormDataContent(),
      }
    );
  }

  getSummary(id: number) {
    return this.http.get<any>(
      this.getEndpoint(`ExemptionFilingRequestDetail/${id}/Summary`),
      this.gethttpOptions()
    );
  }

  getRegistryDownload(id: number) {
    return this.http.get<any>(
      this.getEndpoint(`ExemptionFilingDownloadDetail/${id}`),
      this.gethttpOptions()
    );
  }

  addRegistryDownload() {
    var userId = this.getUser().userId;
    return this.http.post<any>(
      this.getEndpoint(`ExemptionFilingDownloadDetail`),
      `{ "SignatureFirstName": "", "SignatureLastName": "",
       "SignatureMiddleName": "", "SignatureSuffix": "", "SignatureTitle": ""}`,
      this.gethttpOptions()
    );
  }

  updateRegistryDownload(id: any,
    data: any
  ) {
    var userId = this.getUser().userId;
    return this.http.put<any>(
      this.getEndpoint(
        `ExemptionFilingDownloadDetail/${id}`
      ),
      data,
      this.gethttpOptions()
    );
  }

  getFisPay(id: number) {
    return this.http.get<any>(
      this.getEndpoint(`ExemptionFilingRequestBasic/${id}/GetFisDownloadData`),
      this.gethttpOptions()
    );
  }

  downloadLink(downloadId:any): Observable<HttpResponse<Blob>> {
    return this.http.get<Blob>(this.getEndpoint(
      `ExemptionFilingRequestBasic/${downloadId}/DownloadDocument`
    ), {
      headers: this.gethttpOptionsFormDataContent(),
      observe: 'response',
      responseType: 'blob' as 'json'
    });
  }
}
